import { SIDEBAR_DARK } from "@funded-here-interface/common/src/constant/color";
import { createStyles } from "@mantine/styles";

export const useStyles = createStyles(() => ({
  mainContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "max-content",
    background: "#FFFFFF",
    margin: 0,
  },

  hero: {
    position: "absolute",
    left: 240,
    width: "calc(100vw - 204px - 96px)",
    padding: "58px 48px",
  },

  // Mobile
  mobileContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100vh",
    background: "#FFFFFF",
  },

  mobileTopBar: {
    position: "sticky",
    top: 0,
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    gap: 12,
    // Rigid 56px bar. In the flex column, a bare `height` is only a hint the
    // flex algorithm can override — when <main> reflows (or the page is
    // zoomed) the bar stretched to fill the cross space. flexShrink:0 + a
    // min/max height lock it so it can never grow or collapse.
    flex: "0 0 56px",
    minHeight: 56,
    maxHeight: 56,
    padding: "0 16px",
    backgroundColor: SIDEBAR_DARK,
    color: "white",
  },

  mobileTitle: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: "nowrap",
  },

  mobileHero: {
    flex: 1,
    width: "100%",
    padding: "16px",
  },

  drawerBody: {
    padding: 0,
    height: "100%",
  },

  drawerHeader: {
    height: 56,
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    backgroundColor: SIDEBAR_DARK,
  },

  drawerInner: {
    backgroundColor: SIDEBAR_DARK,
  },
}));
